<template>
  <div class="custom-pages">
    <ba-header activeModule="Custom Pages"></ba-header>


    <div class="u-p4 main-content" v-loading="loading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ name: 'dashboard' }">{{companyNameById(companyId)}}</el-breadcrumb-item>
        <el-breadcrumb-item :to="{name :'custom-pages'}">Custom Pages</el-breadcrumb-item>
      </el-breadcrumb>
      <h2 class="c-heading__page u-mt4 u-pt2">Custom Pages</h2>
      <el-button @click="addNew" type="primary">+ Add page</el-button>
      <div class="custom-pages-list">
        <div v-if="pages.length === 0" class="u-mt4 nothing-yet u-text--sm">
          There are no pages created yet.
        </div>

        <el-table v-if="pages.length > 0" class="u-mt4 u-ml2 u-mr5" :data="pages">
          <el-table-column
              prop="title"
              sortable
              label="Title"
          >
            <template slot-scope="scope">
              <router-link class="link-in-black-color" :to="'custom-page-'+ scope.row.id +'/'">
                <div>
                {{scope.row.title}}
                </div>
              </router-link>
            </template>
          </el-table-column>
          <el-table-column
              prop="order"
              label="Order"
              sortable
              width="90"
          >
          </el-table-column>

          <el-table-column label="Type" width="120">
            <template slot-scope="scope">
              <span  v-if="scope.row.is_draft">Draft</span>
              <span  v-else>Published</span>
            </template>
          </el-table-column>

          <el-table-column label="Availability"  width="140">
            <template slot-scope="scope">
              <span v-if="scope.row.is_public">Public</span>
              <span v-else>Enrolled Users</span>
            </template>
          </el-table-column>
          <el-table-column
              label="Actions"
              width="240">
            <template slot-scope="scope">
              <el-dropdown>
                <el-button size="mini">
                  More<i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <router-link :to="'custom-page-'+ scope.row.id +'/'">
                    <el-dropdown-item>Edit</el-dropdown-item>
                  </router-link>
                  <el-dropdown-item  @click.native="willDeletePage(scope.row)">Delete</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>

          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>

</template>

<script>
import axios from 'axios'
import config from '@/config'
import { mapGetters } from 'vuex'

export default {
  components: {
  },
  name: 'ba-insured-messages',
  data () {
    return {
      companyId: this.$route.params.companyId,
      loading: true,
      pages: []
    }
  },
  async beforeMount () {
    await this.loadInitial()
  },
  methods: {
    listUrl () {
      return `${config.url}/v2/company/${this.companyId}/custom-pages/`
    },
    detailsUrlForPage (page) {
      return `${config.url}/v2/custom-pages/${page.id}/`
    },
    async willDeletePage (page) {
      try {
        await this.$confirm(
          `This will permanently remove the page. Continue? To temporary disable the page, try setting this page as Draft.`,
          'Removing custom page'
        )
      } catch (e) {
        // user cancelled
        return
      }

      try {
        this.loading = true
        await axios.delete(this.detailsUrlForPage(page))
        this.$notify({
          message: 'Page deleted successfully.',
          type: 'success'
        })
        await this.loadInitial()
      } catch (e) {
        this.$notify({
          message: 'Failed to delete page.',
          type: 'error'
        })
      } finally {
        this.loading = false
      }
    },
    async addNew () {
      try {
        this.loading = true
        let response = await axios.post(this.listUrl())

        let route = this.createRoute(response.data.id)
        this.$router.push(route, function () {})
      } catch (e) {
        this.$notify({
          message: 'Error occurred while trying to add new custom page.',
          type: 'error'
        })
        console.log('add-custom-page error:', e)
      }
    },
    async loadInitial () {
      try {
        this.loading = true
        let response = await axios.get(this.listUrl())
        this.pages.length = 0
        this.pages.push(...response.data)
      } finally {
        this.loading = false
      }
    },
    createRoute (id) {
      let route = 'custom-page-'+ id +'/'
      return route
    }
  },
  computed: {
    ...mapGetters('shared', ['companyNameById']),
  }
}
</script>

<style lang="scss">

  @import '../../styles/variables';
  .link-in-black-color {
    color: #606266;
  }
</style>

